import _ from 'lodash'
import MutatorFactory from '@/util/import/MutatorFactory'
import { IEntryExported } from '@/types/entry'
import { UnencryptedContent } from '@/types/crypto'

/**
 * Get the schema type for the entry
 */
const getSchemaType = (data: any): string => {
    if (data.location) {
        return 'website'
    }
    return 'note'
}

/**
 * Get the icon for the entry
 */
const getIcon = (data: any): string => {
    if (data.location) {
        return 'globe-americas'
    }
    return 'file'
}

/**
 * Get the tags for the entry
 */
const getTags = (data: any): string[] => {
    if (data.openContents && data.openContents.tags) {
        return data.openContents.tags
    }
    return []
}

/**
 * Find a field in the 1pif record's data.secureContents.fields
 */
const findField = (data: any, field: string): string => {
    const found = _.find(
        data.secureContents.fields,
        (item: any) => item.name === field
    )
    return found ? found.value : ''
}

/**
 * Get the content for a single 1pif record
 */
const getFields = (data: any): UnencryptedContent => {
    if (getSchemaType(data) === 'website') {
        return {
            username: findField(data, 'username') || '',
            password: findField(data, 'password') || '',
            url: data.location || '',
            notes: data.secureContents.notesPlain || '',
            domain: data.location.replace(/https?:\/\//, '').replace(/\/.*/, '') || ''
        }
    } else if (getSchemaType(data) === 'note') {
        return {
            notes: data.secureContents.notesPlain || ''
        }
    }
    return {}
}

/**
 * Convert a single 1pif record to an inactive entry
 */
const convertSingle = (data: any): IEntryExported => ({
    title: data.title,
    schemaType: getSchemaType(data),
    icon: getIcon(data),
    tags: getTags(data),
    fields: getFields(data),
    children: []
})

MutatorFactory.register('1pif', (data: string): IEntryExported[] => {
    // remove the weird crap in the export, and replace with a comma
    data = data.replace(/}\s*\*[*\sa-z0-9-]+\*/g, '},')
    // wrap with array
    data = `[${data}]`
    // remove trailing comma
    data = data.replace(/},\s*]$/, '}]')
    // parse and convert
    return JSON.parse(data).map(convertSingle)
})
